/* RESPONSIBLE TEAM: team-frontend-tech */

const EDITABLE_HTML_TAGS = ['input', 'textarea'];

export function isElementEditable(element?: EventTarget | null) {
  if (!element) {
    return false;
  }

  if (!(element instanceof Element)) {
    return false;
  }

  let isEditableTag = EDITABLE_HTML_TAGS.includes(element.tagName?.toLowerCase?.());
  let hasContentEditable =
    element.hasAttribute?.('contentEditable') &&
    element.getAttribute?.('contenteditable')?.toLowerCase() !== 'false';

  return isEditableTag || hasContentEditable;
}

export function isEventTargetEditable(event: Event) {
  // if the target is is inside an shadow root, the `event.target` will return the element that the shadow root is attached to, instead of the element that the event is triggered on.
  if (event?.composedPath) {
    let composedPath = event.composedPath() as Element[];
    return composedPath.some((element) => isElementEditable(element));
  }

  return isElementEditable(event.target);
}
